export const FEATURE_NAME = '@zerops/zerops/feature/command-palette';
